import { createAction } from "redux-actions";
import { productConstant } from "./productConstant";

export const getAllProduct = createAction(productConstant.GET_ALL_PRODUCT);
